// @ts-nocheck
import { useTranslation } from "react-i18next";
import { Dropdown, message, Select, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";
import { useState } from "react";

export default function C2CCKTS2({}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");

  return (
    <div className="p-4 bg-neutral-800 rounded-lg">
      <div className="flex items-center mb-3">
        <div className="w-6 h-6 flex-shrink-0 rounded-full bg-warning flex items-center justify-center mr-2">
          <i className="fa fa-exclamation-triangle text-xs text-neutral-900"></i>
        </div>
        <p className="text-warning font-medium">
          {translate(getText("您还有支付订单未完成,去完成"))}
        </p>
      </div>
      <p className="text-sm text-neutral-400 ml-8">
        {translate(getText("请先完成现有订单后再进行新的充值"))}
      </p>
    </div>
  );
}
